import VideoScrubber from "@components/VideoScrubber";
import { INVIEW_ENTER } from "@scroll/constants";
import { $, rect } from "@utils/dom";
import { requestInterval } from "@utils/interval";
import { on, off } from "@utils/listener";
import { limit } from "@utils/math";
import ResizeOrientation, { BEFORE_SCROLL_UPDATE } from "@utils/resize";
import Viewport from "@utils/viewport";

class PbRowSaladBar {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.video = $('video', this.el);
    
    this._canvas = null;
    this._ctx = null;
    this._interval = null;
    this._inView = false;
    this._progress = 0;
    this._rect = { top: 0, bottom: 0 };

    this._onResize = this._onResize.bind(this);
    this._onScrollCall = this._onScrollCall.bind(this);
    this._onScrollProgress = this._onScrollProgress.bind(this);
    this._onInterval = this._onInterval.bind(this);
    this._onVideoLoaded = this._onVideoLoaded.bind(this);
  }

  init() {
    this.video = new VideoScrubber(this.video);

    this._onResize();
    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    if( this._interval ) this._interval();

    this.el = null;
    this.emitter = null;
    this.video = null;

    this._canvas = null;
    this._ctx = null;
    this._interval = null;
    this._inView = null;
    this._progress = null;
    this._rect = null;

    this._onResize = null;
    this._onScrollCall = null;
    this._onScrollProgress = null;
    this._onInterval = null;
    this._onVideoLoaded = null;
  }

  _bindEvents() {
    ResizeOrientation.add(this._onResize, BEFORE_SCROLL_UPDATE);

    on(this.video.el, 'canplay', this._onVideoLoaded);

    this.emitter.on('SiteScroll.pb-row-salad-bar', this._onScrollCall);
    this.emitter.on('SiteScroll.scroll', this._onScrollProgress);
  }
  _unbindEvents() {
    ResizeOrientation.remove(this._onResize);

    off(this.video.el, 'canplay', this._onVideoLoaded);

    this.emitter.off('SiteScroll.pb-row-salad-bar', this._onScrollCall);
    this.emitter.off('SiteScroll.scroll', this._onScrollProgress);
  }

  _onResize() {
    const { top, height } = rect(this.el);

    this._rect.top = top + window.scrollY;
    this._rect.bottom = Math.min(Infinity, top + height);
  }
  _onScrollCall(direction, obj) {
    if( obj.el !== this.el ) return;

    this._inView = direction === INVIEW_ENTER;

    if( this._inView ) {
      this.video.scrub(this._progress);

      if( !this._interval ) this._interval = requestInterval( this._onInterval, 1000 / 60);
    } else {
      if( this._interval ) this._interval();
      this._interval = null;

      this.video.scrub(this._progress);
    }
  }
  _onScrollProgress({ y }) {
    if( !this._inView ) return;

    const { top, bottom } = this._rect;

    const height = Math.min(bottom, Viewport.height + bottom - top);
    const distance = limit(0, height, bottom - y);

    this._progress = 1 - distance / height;
  }
  _onInterval() {
    if( !this._inView ) return;

    this.video.scrub(this._progress);
  }
  _onVideoLoaded() {
    if( !this._canvas ) {
      this._canvas = document.createElement('canvas');
      this._canvas.width = 480;
      this._canvas.height = 300;

      this._ctx = this._canvas.getContext("2d", { alpha: false, willReadFrequently: true });
    }

    this._ctx.drawImage(this.video.el, 0, 0);
    
    const pixel = this._ctx.getImageData(0, 0, 1, 1).data;
    const [ r, g, b ] = pixel;

    if( r + g + b === 0 ) return;
    
    off(this.video.el, 'canplay', this._onVideoLoaded);

    const parent = this.el.closest('.pb-row-wrapper');
          parent.style.setProperty('--bg-color', `rgb(${r}, ${g}, ${b})`);
  }
}

export default PbRowSaladBar;
